import axios from 'axios';
import {
  CREATE_AGENT_CONFIG,
  FETCH_AGENT_CONFIG,
  SET_GENERATED_PROMPT,
  SET_AGENT_LOADING,
  SET_AGENT_ERROR,
  DELETE_AGENT_CONFIG, // ✅ Add this
  TOGGLE_AGENT_STATUS
} from './type';

const BASE_URL = process.env.REACT_APP_PORT;
const head = {
      headers: {
        'x-auth-token': localStorage.getItem('token')
      }
    };

// Fetch Agent Config by ID (or default to current user)
export const fetchAgentConfig = (id = '') => async dispatch => {
  dispatch({ type: SET_AGENT_LOADING });
  try {
    const url = `${BASE_URL}/api/ai/agent-config`;
    const res = await axios.get(url,head);
    dispatch({ type: FETCH_AGENT_CONFIG, payload: res.data.data });
    return res.data.data;
  } catch (err) {
    dispatch({ type: SET_AGENT_ERROR, payload: err.message });
    return null;
  }
};

// Create Agent Config
export const createAgentConfig = data => async dispatch => {
  dispatch({ type: SET_AGENT_LOADING });
  try {
    const res = await axios.post(`${BASE_URL}/api/ai/agent-config`, data,head);
    dispatch({ type: CREATE_AGENT_CONFIG, payload: res.data.data });
    return res.data.data;
  } catch (err) {
    dispatch({ type: SET_AGENT_ERROR, payload: err.message });
    return null;
  }
};

// Update Agent Config
export const updateAgentConfig = (id, data) => async dispatch => {
  dispatch({ type: SET_AGENT_LOADING });
  try {
    const res = await axios.put(`${BASE_URL}/api/ai/agent-config`, data,head);
    dispatch({ type: CREATE_AGENT_CONFIG, payload: res.data.data });
    return res.data.data;
  } catch (err) {
    dispatch({ type: SET_AGENT_ERROR, payload: err.message });
    return null;
  }
};

// Delete Agent Config
export const deleteAgentConfig = () => async dispatch => {
  dispatch({ type: SET_AGENT_LOADING });
  try {
    const res = await axios.delete(`${BASE_URL}/api/ai/agent-config`, head);
    dispatch({ type: DELETE_AGENT_CONFIG });
    return res.data;
  } catch (err) {
    dispatch({ type: SET_AGENT_ERROR, payload: err.message });
    return null;
  }
};

export const toggleAgentStatus = (status) => async dispatch => {
  dispatch({ type: SET_AGENT_LOADING });
  try {
    const res = await axios.put(`${BASE_URL}/api/ai/toggle-status`, { status }, head);
    dispatch({ type: TOGGLE_AGENT_STATUS, payload: res.data.data });
    return res.data.data;
  } catch (err) {
    dispatch({ type: SET_AGENT_ERROR, payload: err.message });
    return null;
  }
};

// Generate Prompt
export const generateAgentPrompt = data => async dispatch => {
  dispatch({ type: SET_AGENT_LOADING });
  try {
    const res = await axios.post(`${BASE_URL}/api/ai/agent/generate-prompt`, data,head);
    dispatch({ type: SET_GENERATED_PROMPT, payload: res.data.prompt });
    return res.data.prompt;
  } catch (err) {
    dispatch({ type: SET_AGENT_ERROR, payload: err.message });
    return null;
  }
};
